import * as React from 'react';

// Local Resources
import ImageButton from './imagebutton';
import {
	ANALYSIS_TYPE,
	AnalysisResultToIconState,
	MeasurementStatetoHTML,
} from '../components/enums';

// MaterialUI

// Tippy.JS Resources
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/animations/shift-away.css';


const UNIT_SHAPE = {
	HORIZONTAL: 'h',
	VERTICAL: 'v',
	SQUARE: 's'
};

const DIM_SHORT = 51;
const DIM_LONG = 100;

function UnitShapeToLetter(unitShape) {
	switch (unitShape) {
		case 0:
			return UNIT_SHAPE.SQUARE;

		case 1:
			return UNIT_SHAPE.HORIZONTAL;

		case 2:
			return UNIT_SHAPE.VERTICAL;
			
		default:
			return UNIT_SHAPE.VERTICAL;
	}
}
			
function GetUnitSize(unitShape, scale = 1.0) {

	let shortDimension = DIM_SHORT * scale;
	let longDimension = DIM_LONG * scale;

	if (unitShape) {
		switch (unitShape) {
			case UNIT_SHAPE.VERTICAL:
				return [shortDimension, longDimension];

			case UNIT_SHAPE.HORIZONTAL:
				return [longDimension, shortDimension];

			case UNIT_SHAPE.SQUARE:
				return [longDimension, longDimension];

			default:
				return [shortDimension, longDimension]; // Default is vertical
		}
	} else {
			return [shortDimension, longDimension]; // Default is vertical
	}
}

function BuildPopover(stringNum, unitNum, unitState) {
	const unitID = `String ${stringNum} Unit ${unitNum}`;

	const voltage = MeasurementStatetoHTML('Unit', unitState.voltage, ANALYSIS_TYPE.VOLTAGE);
	const impedance = MeasurementStatetoHTML('Unit', unitState.impedance, ANALYSIS_TYPE.IMPEDANCE);
	const temperature = MeasurementStatetoHTML('Unit', unitState.temperature, ANALYSIS_TYPE.TEMPERATURE);
	const diffTemp = MeasurementStatetoHTML('Unit', unitState.diff_temperature, ANALYSIS_TYPE.DIFF_TEMPERATURE);

	return (
		<span
			style={{
				fontFamily: 'Saira, sans-serif',
				fontWeight: '600'
			}}
		>
			<p><b>{unitID}</b></p>
			{voltage}<br />
			{impedance}<br />
			{temperature}<br />
			{diffTemp}<br />
		</span>
	);
}

export default function UnitIcon(props) {

	const {locationNum, stringNum, unitNum, unitShape, unitState, unitAlarms, scale = 1.0} = props;

	const shape = UnitShapeToLetter(unitShape);
	const state = AnalysisResultToIconState(unitState.overall);

	const imgPath = `/images/batterymap_icons/unit_${shape}_${state}.svg`;

	const [ width, height ] = GetUnitSize(shape, scale);

	const popover = BuildPopover(stringNum, unitNum, unitState);

	return (
		<Tippy
			content={popover}
			placement="bottom"
			animation="shift-away"
		>
			<span tabIndex="0">
				<ImageButton
					imgUrl={imgPath}
					imgWidth={width}
					imgHeight={height}
					buttonText={unitNum}
					linkUrl={`/location/${locationNum}/trend/unit?string=${stringNum}&unit=${unitNum}`}
				/>
			</span>
		</Tippy>
	);
}